import React, { useState } from 'react';
import {
  Box,
  Typography,
  Chip,
  Grid,
  Button,
  Collapse,
  Card,
  CardContent,
  // Tooltip,
  // Badge,
  // Divider,
  // useTheme,
  // useMediaQuery,
} from '@mui/material';
import {
  // Work,
  // Business,
  // LocationOn,
  // Schedule,
  // Person,
  // Money,
  // Email,
  // Phone,
  // CalendarToday,
  // Computer,
  ExpandMore,
  ExpandLess,
  Send,
  CheckCircleOutlineTwoTone,
  // Email,
  // Phone,
  // Insights,
} from '@mui/icons-material';
import { JobDetails, Feed } from '@/constants/types';
import { feedService } from '@/services/feed/feedService';
import { useAuth } from '@/hooks';
import moment from 'moment';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { updateFeedStats, useAppDispatch } from '@/store';

interface JobDetailsCardProps {
  jobDetails: JobDetails;
  feedUserId: string;
  feed?: Feed; // Add feed prop for view count and application count
  defaultExpanded?: boolean;
}
const experienceLevels:any = {
  entry: "Fresher / Entry Level – 0 to 1 Year",
  junior: "Junior Level – 1 to 3 Years",
  mid: "Mid-Level – 3 to 5 Years",
  senior: "Senior Level – 5 to 8 Years",
  manager: "Managerial Level – 8 to 12 Years",
  head: "Leadership / Head Level – 12 to 18 Years",
  executive: "Director / C-Level – 18+ Years"
};
export const JobDetailsCard: React.FC<JobDetailsCardProps> = ({ jobDetails, feedUserId, feed, defaultExpanded = false }) => {
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { user } = useAuth();
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(defaultExpanded);
    const dispatch = useAppDispatch();
  
  const isOwnPost = user?.id === feedUserId;

  const formatSalary = () => {
    if (!jobDetails.salary?.min && !jobDetails.salary?.max) return null;
    
    const { min, max, denomination = 'lakh', currency = 'INR', period = 'yearly' } = jobDetails.salary;
    let salaryText = '';
    
    if (min && max) {
      salaryText = `${min} - ${max} ${denomination}`;
    } else if (min) {
      salaryText = `${min}+ ${denomination}`;
    } else if (max) {
      salaryText = `Up to ${max} ${denomination}`;
    }
    
    return salaryText ? `${salaryText} ${currency} (${period})` : null;
  };

  const formatJobType = (type: string) => {
    return type.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  };

    const formatExperienceLevel = (level: string) => {
    // return level.charAt(0).toUpperCase() + level.slice(1) + ' Level';
    return experienceLevels[level]
  };

  const formatNoticeType = (notice: string) => {
    return notice === 'immediate' ? 'Immediate' : notice.replace('-', ' ');
  };

  const formatWorkMode = (mode: string) => {
    return mode.charAt(0).toUpperCase() + mode.slice(1);
  };

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  const handleApply = async () => {
    try {
     await feedService.applyForJob(jobDetails.feedId);
      console.log('Application submitted successfully');
       toast.success('Application submitted successfully')
        dispatch(updateFeedStats(feed?._id!))
    } catch (error:any) {
      toast.error(error.response.data.message)
      console.error('Error submitting application:', error);
    }
  };

  return (
    <Box sx={{ mt: 1 }}>
      {/* View Details Button and Stats */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Button
          onClick={toggleExpanded}
          endIcon={expanded ? <ExpandLess /> : <ExpandMore />}
          size="small"
          sx={{
            textTransform: 'none',
            color: '#0a66c2',
            fontWeight: 600,
            px: 0,
            fontSize: '0.875rem',
            '&:hover': { bgcolor: 'transparent', textDecoration: 'underline' },
          }}
        >
          {expanded ? 'Hide details' : 'View job details'}
        </Button>

        {/* Right side - View count and Application count */}
        {feed && isOwnPost &&(
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            {/* Application count - Show for job feeds */}
            {feed.feedType?.name === 'job' && (feed.applicationCount ?? 0) >= 0 && (
              <Button
              variant='contained'
                       onClick={() => {
                    const params = new URLSearchParams();
                    if (feed.title) params.append('title', feed.title);
                    if (feed.feedType?.name) params.append('type', feed.feedType.name);
                    if (feed.applicationCount !== undefined) params.append('count', feed.applicationCount.toString());
                    
                    navigate(`/applications/${feed._id}`);
                  }}
              >
            Applications : {feed?.applicationCount && feed?.applicationCount >=100 ? "99+": feed.applicationCount }
              </Button>
              // <Tooltip title="View applications">
              //   <Badge
              //     badgeContent={feed.applicationCount}
              //     color="error"
              //     onClick={() => {
              //       const params = new URLSearchParams();
              //       if (feed.title) params.append('title', feed.title);
              //       if (feed.feedType?.name) params.append('type', feed.feedType.name);
              //       if (feed.applicationCount !== undefined) params.append('count', feed.applicationCount.toString());
                    
              //       navigate(`/applications/${feed._id}`);
              //     }}
              //     sx={{
              //       cursor: 'pointer',
              //       '&:hover': {
              //         opacity: 0.8,
              //       },
              //     }}
              //   >
              //     {/* <Insights sx={{ fontSize: 24, color: 'primary.main' }} /> */}
              //   </Badge>
              // </Tooltip>
            )}
            
            {/* View count */}
            {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <VisibilityOutlined sx={{ fontSize: 16, color: 'text.secondary' }} />
              <Typography variant="caption" color="text.secondary">
                {feed.stats?.views || 0}
              </Typography>
            </Box> */}
          </Box>
        )}
      </Box>

      {/* Collapsible Job Details - LinkedIn Style */}
      <Collapse in={expanded}>
        <Card variant="outlined" sx={{ borderRadius: 2, border: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}>
          <CardContent sx={{ p: 2 }}>
            <Grid container spacing={2}>
              {/* Company Name */}
              {jobDetails.companyInfo?.companyname && (
                <Grid size={{ xs: 6, sm: 4 }}>
                  <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                    Company
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {jobDetails.companyInfo.companyname}
                  </Typography>
                </Grid>
              )}

              {/* Job Category */}
              {jobDetails.jobCategoryId?.name && (
                <Grid size={{ xs: 6, sm: 4 }}>
                  <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                    Category
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {jobDetails.jobCategoryId.name}
                  </Typography>
                </Grid>
              )}

              {/* Job Type */}
              <Grid size={{ xs: 6, sm: 4 }}>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                  Job Type
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {formatJobType(jobDetails.jobType)}
                </Typography>
              </Grid>

              {/* Experience */}
              <Grid size={{ xs: 6, sm: 4 }}>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                  Experience
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {formatExperienceLevel(jobDetails.experienceLevel)}
                </Typography>
              </Grid>

              {/* Vacancies */}
              <Grid size={{ xs: 6, sm: 4 }}>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                  Vacancies
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {jobDetails.noOfVacancy} position{jobDetails.noOfVacancy > 1 ? 's' : ''}
                </Typography>
              </Grid>

              {/* Work Mode */}
              <Grid size={{ xs: 6, sm: 4 }}>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                  Work Mode
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {formatWorkMode(jobDetails.workMode)}
                </Typography>
              </Grid>

              {/* Salary */}
              {formatSalary() && (
                <Grid size={{ xs: 6, sm: 4 }}>
                  <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                    Salary
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: '#057642' }}>
                    {formatSalary()}
                  </Typography>
                </Grid>
              )}

              {/* Notice Period */}
              <Grid size={{ xs: 6, sm: 4 }}>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                  Notice Period
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {formatNoticeType(jobDetails.noticeType)}
                </Typography>
              </Grid>

              {/* Skills */}
              {jobDetails.skills && jobDetails.skills.length > 0 && (
                <Grid size={{ xs: 12, sm: 8 }}>
                  <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500, display: 'block', mb: 0.5 }}>
                    Required Skills
                  </Typography>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {jobDetails.skills.map((skill, index) => (
                      <Chip key={index} label={skill} size="small" sx={{ height: 24, fontSize: '0.75rem', bgcolor: '#e8f5e9', color: '#2e7d32' }} />
                    ))}
                  </Box>
                </Grid>
              )}

              {/* Locations */}
              <Grid size={{ xs: 12, sm: 4 }}>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500, display: 'block', mb: 0.5 }}>
                  Locations
                </Typography>
                {jobDetails.location && jobDetails.location.length > 0 ? (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {jobDetails.location.map((loc, index) => (
                      <Chip key={index} label={loc} size="small" sx={{ height: 24, fontSize: '0.75rem' }} />
                    ))}
                  </Box>
                ) : (
                  <Typography variant="body2">NA</Typography>
                )}
              </Grid>

              {/* Application Deadline */}
              {jobDetails.applicationDeadline && (
                <Grid size={{ xs: 12 }}>
                  <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                    Deadline
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: '#b86e00' }}>
                    {moment(jobDetails.applicationDeadline).format('MMM DD, YYYY')} ({moment(jobDetails.applicationDeadline).fromNow()})
                  </Typography>
                </Grid>
              )}

              {/* Apply Button - LinkedIn Style */}
              {!isOwnPost && (
                <Grid size={{ xs: 12 }}>
                  <Button
                    variant="contained"
                    fullWidth
                    startIcon={jobDetails.isApplied ? <CheckCircleOutlineTwoTone /> : <Send />}
                    onClick={handleApply}
                    disabled={jobDetails.isApplied}
                    sx={{
                      mt: 1,
                      textTransform: 'none',
                      fontWeight: 600,
                      py: 1,
                      borderRadius: 5,
                      bgcolor: jobDetails.isApplied ? '#057642' : '#0a66c2',
                      '&:hover': { bgcolor: jobDetails.isApplied ? '#057642' : '#004182' },
                      '&.Mui-disabled': { bgcolor: '#057642', color: 'white' },
                    }}
                  >
                    {jobDetails.isApplied ? 'Applied' : 'Easy Apply'}
                  </Button>
                </Grid>
              )}

              {/* Contact Actions */} 
              {/* hiede tempory */}
               {(jobDetails.contactDetails?.email || jobDetails.contactDetails?.mobile) && false && (
                <Grid size={{ xs: 12 }}>
                  {/* <Divider sx={{ my: 2 }} /> */}
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    Contact Information
                  </Typography>
                  {/* <Box sx={{ 
                    display: 'flex', 
                    gap: 2, 
                    flexDirection: { xs: 'column', sm: 'row' }
                  }}>
                    {jobDetails.contactDetails.email && (
                      <Button
                        variant="contained"
                        startIcon={<Email />}
                        href={`mailto:${jobDetails.contactDetails.email}`}
                        fullWidth={isMobile}
                        sx={{ textTransform: 'none' }}
                      >
                        Enquire via Email
                      </Button>
                    )}
                    {jobDetails.contactDetails.mobile && (
                      <Button
                        variant="outlined"
                        startIcon={<Phone />}
                        href={`tel:${jobDetails.contactDetails.mobile}`}
                        fullWidth={isMobile}
                        sx={{ textTransform: 'none' }}
                      >
                        Call to Enquire
                      </Button>
                    )}
                  </Box> */}
                </Grid>
              )} 
            </Grid>
          </CardContent>
        </Card>
      </Collapse>
    </Box>
  );
};